"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
(function ($) {
    var _a;
    var _b = window.getCookie, getCookie = _b === void 0 ? noop : _b, _c = window.bestcasinos,
        bestcasinos = _c === void 0 ? {} : _c,
        _d = window.dataLayer, dataLayer = _d === void 0 ? {
            push: noop
        } : _d;
    var LOCATION = 'location';
    var CID = 'cid';
    var ELEMENT = 'element';
    var CASINO = 'cas_name';
    var POSITION = 'position';
    var USERCOUNTRY = 'user_country';
    var BONUS_LABEL = 'bonus_label';
    var BONUS_VALUE = 'bonus_value';

    // TODO: change selector to a lighter version with .js- prefix
    var REF_IGNORE_SELECTOR = 'a';
    var noopContext = (_a = {},
        _a[LOCATION] = '',
        _a[CID] = '',
        _a[ELEMENT] = '',
        _a[CASINO] = '',
        _a[POSITION] = '',
        _a[USERCOUNTRY] = '',
        _a[BONUS_LABEL] = '',
        _a[BONUS_VALUE] = '',
        _a);
    var _e = bestcasinos.referralPatterns, referralPatterns = _e === void 0 ? {} : _e;
    var defaultContextPattern = LOCATION + "={" + LOCATION + "}&" + CID + "={" + CID + "}&" + ELEMENT + "={" + ELEMENT + "}&" + CASINO + "={" + CASINO + "}&" + BONUS_LABEL + "={" + BONUS_LABEL + "}&" + BONUS_VALUE + "={" + BONUS_VALUE + "}&" + USERCOUNTRY + "={" + USERCOUNTRY + "}&" + POSITION + "={" + POSITION + "}";
    window.makeRefHandler = makeRefHandler;
    window.getRefLinkHandler = getRefLinkHandler;

    function makeRefHandler(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.refKey, refKey = _c === void 0 ? 'ref' : _c, _d = _b.ignoreSelector,
            ignoreSelector = _d === void 0 ? REF_IGNORE_SELECTOR : _d;
            return function handleReferralClick(e) {
            if(e.target.classList.contains(ignoreSelector)){
                return;
            }
            var $me = $(this),
                $target = $(e.target),
                id = parseInt($me.data(refKey) || $me.data('casino-target')),
                element = $me.data('ga-context-element'),
                position = $me.data('position'),
                user_country = $me.data('user-country'),
                bonus_label = $me.data('bonus-label'),
                bonus_value = $me.data('bonus-value'),
                id_bonus = $me.data('bonus-id'),
                cas_name = $me.data('casino-name') || $me.data('betting') || $me.data('casino');

            if ($target.is(ignoreSelector) ||
                ($target.closest(ignoreSelector)).length > 0) {
                return;
            }

            if (!id) {
                return;
            }
            
            e.preventDefault();
            e.stopPropagation();
            var context = __assign(__assign({}, getGlobalReferralContext()), {
                id: id,
                id_bonus: id_bonus,
                element: element,
                cas_name: cas_name,
                position: position,
                user_country: user_country,
                bonus_label: bonus_label,
                bonus_value: bonus_value
            });
            var link = buildReferralLink({
                id: id,
                context: context
            });
            if (link) {
                pushDataLayer(context);
                window.open(link, '_blank');
            }
        };
    }

    function getRefLinkHandler(elem = null, e = null) {
        let link = null;
        const refKey = 'ref';
        if( elem === null || elem === undefined || elem.length === 0) {
            return link;
        }
        var $me = $(elem),
            $target = $(e.target),
            id = parseInt($me.data(refKey) || $me.data('casino-target')),
            element = $me.data('ga-context-element'),
            position = $me.data('position'),
            user_country = $me.data('user-country'),
            bonus_label = $me.data('bonus-label'),
            bonus_value = $me.data('bonus-value'),
            id_bonus = $me.data('bonus-id'),
            cas_name = $me.data('casino-name') || $me.data('betting') || $me.data('casino');

        if (!id) {
            return;
        }

        var context = __assign(__assign({}, getGlobalReferralContext()), {
            id: id,
            id_bonus: id_bonus,
            element: element,
            cas_name: cas_name,
            position: position,
            user_country: user_country,
            bonus_label: bonus_label,
            bonus_value: bonus_value
        });
        link = buildReferralLink({
            id: id,
            context: context
        });
        if (link) {
            // return link
            pushDataLayer(context);
            // window.open(link, '_blank');
        }

        return link;
    }



    function pushDataLayer(context) {
        let data = {
            'event': 'GAevent',
            'eventCategory': 'toCasino',
            'eventAction': context.element,
            'eventLabel': context.cas_name,
            'eventCID': getGoogleCid()
        }

        if(context.bonus_label){
            data.eventBonusName = context.bonus_label;
        }

        if(context.bonus_value){
            data.eventBonusConditions = context.bonus_value;
        }

        if(context.id){
            data.eventLabelID = context.id;
        }

        if(context.id_bonus){
            data.eventBonusID = context.id_bonus;
        }

        if(context.position){
            data.eventPosition = context.position;
        }

        dataLayer.push(data);
    }

    function buildReferralLink(_a) {
        var id = _a.id, _b = _a.context, context = _b === void 0 ? noopContext : _b, _c = _a.contextPattern,
            contextPattern = _c === void 0 ? defaultContextPattern : _c;
        var contextQueryStr = contextPattern.replace(/\{(\w+)\}/gi, function (match, key) {
            return context[key] || '';
        });
        var link = "/to-casino/?id=" + id + "&" + contextQueryStr;
        return link;
    }

    function getGlobalReferralContext() {
        var _a;
        var location = window.location.href;
        var cid = getGoogleCid();
        return _a = {},
            _a[LOCATION] = location,
            _a[CID] = cid,
            _a;
    }

    function getGoogleCid() {
        var _cid = getCookie('_ga');
        // console.log(_cid);
        // console.log(typeof _cid);

        if (_cid === undefined || !_cid ||  _cid == '' || _cid === null) {
            return '';
        }
        if(typeof _cid === 'string'){
            let splitted = _cid.split('.');
            return splitted[2] + '.' + splitted[3];

        }else{
            console.warn('Cookie _ga not found or not a string:', _cid);
            return '';
        }

    }

    function getHostName(url) {
        var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
        if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
            return match[2];
        } else {
            return null;
        }
    }

    function noop() {
    }
})(jQuery);
